module.exports = __webpack_public_path__ + "media/images/riders/ANTON_COOPER-891204590a88bf47117d22425c64362a.png";